export default {
  data() {
    return {};
  }
};